export class SalesTypes {
  constructor(instance) {
    this.instance = instance;
  }

  getSalesTypes(filter) {
    return this.instance.get('/v1/cad-salesTypes/', {
      params: filter || null,
    });
  }

  getSaleType(filter, id) {
    return this.instance.get(`/v1/cad-salesTypes/${id}`, {
      params: filter || null,
    });
  }

  addSalesTypes(data) {
    return this.instance.post(`/v1/cad-salesTypes/`, data);
  }

  editSalesTypes(id, data) {
    return this.instance.put(`/v1/cad-salesTypes/${id}`, data);
  }

  deleteSalesType(id) {
    return this.instance.delete(`/v1/cad-salesTypes/${id}`);
  }
}

export default SalesTypes;
